import script from "./PatentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PatentForm.vue?vue&type=script&setup=true&lang=js"

import "./PatentForm.vue?vue&type=style&index=0&id=a6b9e65e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6b9e65e"]])

export default __exports__